import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { createQueryString } from 'src/utils'

export default {
  openUploadModal,
  refreshGrid,
  createDocument,
  fetch,
  select,
  remove,
  generateSignedUrl,
  readRoster,
  getDocumentURL,
}

async function refreshGrid ({ commit }) {
  console.log('refreshGrid')
  commit('startRefresh')
  commit('endRefresh')
}

async function openUploadModal ({ commit, dispatch, state }, payload = {}) {
  commit('clearDocumentForm')
  commit('clearUploadFormExceptEntityID')

  if (payload.LK_ENTITY_ID) {
    commit('updateUploadForm', {
      field: 'LK_ENTITY_ID',
      value: payload.LK_ENTITY_ID
    })
  }
  if (payload.ENTITY_ITEM_ID) {
    commit('updateUploadForm', {
      field: 'ENTITY_ITEM_ID',
      value: payload.ENTITY_ITEM_ID
    })
  }
  if (payload.LK_DOCUMENT_TYPE_ID) {
    commit('updateUploadForm', {
      field: 'LK_DOCUMENT_TYPE_ID',
      value: payload.LK_DOCUMENT_TYPE_ID
    })
  }
  commit('openUpload')
}

async function generateSignedUrl ({ commit, state, rootState }, file) {
  const contentType = file.type // To send the correct Content-Type
  const { uploadForm } = state
  const { fileTypes } = rootState.shared

  uploadForm.LK_FILE_TYPE_ID = _.find(fileTypes, { 'CONTENT_TYPE': contentType }).LK_FILE_TYPE_ID

  try {
    const response = await api.post('/documents/generateSignedUrl', { uploadForm, contentType })
    const { success, payload } = response.data
    commit('updateUploadForm', { field: 'DOCUMENT_ID', value: payload.DOCUMENT_ID })
    if (!success) throw response
    const signedUrl = payload.signedUrl
    return signedUrl
  } catch (response) {
    return response
  }
}

async function createDocument ({ commit, state, rootState }, file) {
  const contentType = file.type // To send the correct Content-Type
  const { uploadForm } = state
  const { fileTypes } = rootState.shared

  uploadForm.LK_FILE_TYPE_ID = _.find(fileTypes, { 'CONTENT_TYPE': contentType }).LK_FILE_TYPE_ID

  try {
    const response = await api.post('/documents/upload', { uploadForm, contentType })
    console.log('response before', response)
    if (!response.data.success) throw response
    return response
  } catch (response) {
    return response
  }
}

async function fetch ({ commit }, { pagination, filter, columns, customFilter }) {
  commit('isLoading')
  try {
    const query = createQueryString({ pagination, filter, columns, customFilter })
    const { data: response } = await api.get('/documents/fetch/' + query)
    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response

    commit('setList', { documents: payload.documents })
    // notify.respond(response)
    return response
  } catch (response) {
    console.log('errror....')
    commit('doneLoading')
    // notify.respond(response)
    return response
  }
}

async function select ({ commit, state, dispatch }, payload) {
  try {
    const { documentForm } = state
    commit('clearDocumentForm')
    // const address = (payload.ADDRESSES) ? payload.ADDRESSES[0] : false
    // if (address) commit('setAddressForm', { address: payload.ADDRESSES[0] })
    commit('setDocumentForm', { selectedDocument: payload })
    const response = await api.get('/documents/downloadDocument', { params: { DOCUMENT_S3_KEY: documentForm.DOCUMENT_S3_KEY } })
    if (!response.data.success) throw response
    const signedUrl = response.data.payload
    window.open(signedUrl, '_blank')
  } catch (response) {
    notify.respond(response.data)
    return response
  }
}

async function remove ({ commit, state, dispatch }, DOCUMENT_ID) {
  try {
    const { data: response } = await api.post('/documents/remove', { DOCUMENT_ID })
    const { success } = response
    if (!success) throw response
    commit('updateUploadForm', { field: 'DOCUMENT_ID', value: null })
    notify.respond(response)
    return success
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function readRoster({ state, commit, }, { key, document_id, class_id }) {
  try {
    const response = await api.post('/jobs/readRoster/', {
      name: key,
      document_id,
      class_id,
    })

    if (!response || response.data.error) {
      throw response.data.message || 'Unknown error occurred'
    }

    if (response.data.code === 'JOB_EXISTS') {
      return response.data.rosterJobId
    }

  } catch (err) {
    console.log('roster err:', err)
    throw err
  }
}

async function getDocumentURL({ commit, state, dispatch }, payload) {
  try {
    const { documentForm } = state
    commit('clearDocumentForm')
    commit('setDocumentForm', { selectedDocument: payload })
    const response = await api.get('/documents/downloadDocument', { params: { DOCUMENT_S3_KEY: documentForm.DOCUMENT_S3_KEY } })
    if (!response.data.success) throw response
    const signedUrl = response.data.payload

    return signedUrl
  } catch (response) {
    notify.respond(response.data)
    return response
  }
}
